// 框选模板公共方法
const makeTemplateCommon = {
    childSpinMethod: function (imgSrc, rotationAngles, canvasObj) {
        fabric.Image.fromURL(
            imgSrc,
            (img) => {
                if (rotationAngles.hasOwnProperty(imgSrc)) {
                    const rotationInfo = rotationAngles[imgSrc]
                    img.rotate(rotationInfo)
                }
                let scaleX = canvasObj.width / img.width
                let scaleY = canvasObj.height / img.height
                //设置图片宽高为画布宽高（否则重新渲染会还原图片宽高）
                img.scaleToWidth(canvasObj.width)
                img.scaleToHeight(canvasObj.height)
                //旋转之后，设置图片的缩放比
                img.set({
                    scaleX: scaleX,
                    scaleY: scaleY,
                })
                canvasObj.setBackgroundImage(img, canvasObj.renderAll.bind(canvasObj))
            },
            {
                crossOrigin: 'anonymous',
            }
        )
    },  //子页面旋转图片方法
    showsetCustomControlsbutton: function (obj) {
        obj.visible = true
        obj.hasBorders = true
        if (obj.editButton) obj.editButton.visible = false
        if (obj.saveButton) {
            obj.saveButton.visible = true
            obj.saveButton.bringToFront()
        }
        if (obj.deleteButton) {
            obj.deleteButton.visible = true
            obj.deleteButton.bringToFront()
        }
        if (obj.cutTypeButton) {
            if (!obj.isFront) obj.cutTypeButton.visible = false
            else obj.cutTypeButton.visible = true
        }
        obj.setControlsVisibility({
            mt: true,
            mb: true,
            ml: true,
            mr: true,
            mtr: true,
            tl: true,
            tr: true,
            bl: true,
            br: true,
        })
    },  //调整矩形大小控制点以及按钮的显示
    hidesetCustomControlsbutton: function (obj) {
        obj.hasBorders = false
        if (obj.saveButton) obj.saveButton.visible = false
        if (obj.deleteButton) obj.deleteButton.visible = false
        if (obj.cutTypeButton) obj.cutTypeButton.visible = false
        obj.setControlsVisibility({
            mt: false,
            mb: false,
            ml: false,
            mr: false,
            mtr: false,
            tl: false,
            tr: false,
            bl: false,
            br: false,
        })
    },  //调整矩形大小控制点以及按钮的隐藏
    pageSwitching: function (canvasObj, imgSrc, magnifyCanvasZoom, containerWidth, containerHeight, imgZoomArray, paperImgs, totalRect, saveCoordinatesList) {
        return new Promise((resolve) => {
            var backgroundImage = new Image()
            backgroundImage.src = imgSrc
            backgroundImage.crossOrigin = 'anonymous' // 关键！
            backgroundImage.onload = function () {
                let backgroundWidth = backgroundImage.width
                let backgroundHeight = backgroundImage.height
                backgroundImage = canvasObj.backgroundImage
                if (imgZoomArray.hasOwnProperty(imgSrc)) {
                    let imgZoom = imgZoomArray[imgSrc].zoom
                    magnifyCanvasZoom = imgZoom
                } // 获取缩放比例
                // 获取背景图片宽高
                var canvasWidth = containerWidth
                var canvasHeight = containerHeight

                // 计算画布的新宽高
                var newCanvasWidth = canvasWidth * magnifyCanvasZoom
                var newCanvasHeight = canvasHeight * magnifyCanvasZoom
                // 计算缩放比例
                var imgScaleX = newCanvasWidth / backgroundWidth
                var imgScaleY = newCanvasHeight / backgroundHeight
                // 更新背景图片的缩放比例
                backgroundImage.scaleX = imgScaleX
                backgroundImage.scaleY = imgScaleY
                canvasObj.enableRetinaScaling = false   // ⭐在高 DPR 屏幕下，禁用 Fabric.js 的自动 DPR 处理，手动控制尺寸以避免坐标偏移（关键）
                canvasObj.setDimensions({ width: newCanvasWidth, height: newCanvasHeight })   // 设置画布尺寸
                canvasObj.calcOffset()  // 重新计算画布的偏移量，确保坐标计算正确
                // 获取所有矩形和按钮组对象
                var rectangles = canvasObj.getObjects('rect')
                var texttangles = canvasObj.getObjects('text')
                var buttonGroups = canvasObj.getObjects().filter(function (obj) {
                    return obj.type !== 'rect' && obj.type !== 'text' && !obj.isQuestionText
                })   //操作按钮
                var textGroups = canvasObj.getObjects().filter((obj) => {
                    return obj.isQuestionText
                })   //题号
                if (rectangles && rectangles.length > 0) {
                    rectangles.forEach(function (rect) {
                        canvasObj.remove(rect)
                    }) // 删除所有矩形对象
                }
                if (buttonGroups && buttonGroups.length > 0) {
                    buttonGroups.forEach(function (group) {
                        canvasObj.remove(group)
                    }) // 删除所有按钮组对象
                }
                if (texttangles && texttangles.length > 0) {
                    texttangles.forEach(function (text) {
                        canvasObj.remove(text)
                    }) //移除所有题号
                }
                if (textGroups && textGroups.length > 0) {
                    textGroups.forEach((group) => {
                        canvasObj.remove(group)
                    })
                }
                canvasObj.renderAll() // 更新画布
                // 遍历每个文本对象
                texttangles.forEach(function (texttangle) {
                    texttangle.set({
                        left: Number((texttangle.left * imgScaleX).toFixed(2)), // 距离画布左边的距离
                        top: Number((texttangle.top * imgScaleY).toFixed(2)), // 距离画布顶部的距离
                        fill: 'red', // 文字颜色
                        fontSize: 15, // 字体大小
                        fontFamily: 'Arial', // 字体类型
                        angle: 0, // 旋转角度
                        selectable: false,
                    })
                    if (texttangle.left >= 0 && texttangle.left < canvasObj.width && texttangle.top >= 0 && texttangle.top < canvasObj.height) canvasObj.add(texttangle)
                })
                rectangles.forEach(function (rectangle) {
                    if (
                        (paperImgs.length > 0 && imgSrc == paperImgs[0].image && rectangle.isFront == true) ||
                        (paperImgs.length > 1 && imgSrc == paperImgs[1].image && rectangle.isFront == false)
                    ) {
                        // 计算矩形的新的位置和大小
                        var rectLeft = Number((rectangle.left * imgScaleX).toFixed(2))
                        var rectTop = Number((rectangle.top * imgScaleY).toFixed(2))
                        var rectWidth = Number((rectangle.width * imgScaleX).toFixed(2))
                        var rectHeight = Number((rectangle.height * imgScaleY).toFixed(2))
                        //判断矩形是否超出画布，超出画布则不添加
                        if (rectLeft < 0 || rectLeft > canvasObj.width || rectLeft + rectWidth > canvasObj.width || rectTop < 0 || rectTop > canvasObj.height || rectTop + rectHeight > canvasObj.height) {
                            let totalIndex = totalRect.findIndex((e) => e.left == rectangle.left && e.top == rectangle.top && e.width == rectangle.width && e.height == rectangle.height)
                            if (totalIndex != -1) totalRect.splice(totalIndex, 1)
                            if (Array.isArray(saveCoordinatesList)) {   //判断是否为数组
                                let saveIndex = saveCoordinatesList.findIndex((e) => e.x == rectangle.left && e.y == rectangle.top && e.width == rectangle.width && e.height == rectangle.height)
                                if (saveIndex != -1) saveCoordinatesList.splice(saveIndex, 1)
                            } else saveCoordinatesList = {}
                            return
                        }
                        rectangle.set({ left: rectLeft, top: rectTop, width: rectWidth, height: rectHeight })   // 更新矩形对象的位置和大小
                        if (rectangle.line) rectangle.line.set({ x1: rectangle.line.x1 * imgScaleX, y1: rectangle.line.y1 * imgScaleY, x2: rectangle.line.x2 * imgScaleX, y2: rectangle.line.y2 * imgScaleY })  //线定位
                        rectangle.setCoords()  // 更新矩形的控制点坐标，确保在高 DPR 屏幕下控制点位置正确
                    }
                    // 将矩形添加到画布
                    canvasObj.add(rectangle)
                    if (rectangle.line) canvasObj.add(rectangle.line)
                    if (!rectangle.isOptions && !rectangle.isScoreRect) {
                        // 更新按钮组的位置信息
                        var buttonGroupLeft = rectLeft + rectWidth
                        var buttonGroupTop = rectTop - 20
                        var buttonLeft = 0
                        var buttonTop = 0

                        // 更新对应矩形下方的按钮位置
                        var buttonsInGroup = buttonGroups.filter(function (obj) {
                            return obj.selectedRect === rectangle
                        })
                        var buttonSpacing = 50 // 按钮之间的间距
                        buttonsInGroup.forEach(function (button, index) {
                            if (rectLeft > canvasWidth / 2) {
                                //位于右侧
                                if (rectTop > canvasHeight / 2) {
                                    //位于右下侧
                                    if (button == buttonsInGroup[0]) {
                                        buttonLeft = buttonGroupLeft - buttonSpacing
                                        buttonTop = buttonGroupTop
                                    } else {
                                        // buttonLeft = canvasObj.lowerCanvasEl.id == 'candidateNoCanvas' ? buttonGroupLeft - 25 - (buttonsInGroup.length - index) * buttonSpacing : buttonGroupLeft - (buttonsInGroup.length - index) * buttonSpacing
                                        buttonLeft = buttonGroupLeft - (buttonsInGroup.length - index) * buttonSpacing
                                        buttonTop = buttonGroupTop
                                    }
                                } else {
                                    if (button == buttonsInGroup[0]) {
                                        buttonLeft = buttonGroupLeft - buttonSpacing
                                        buttonTop = rectTop + rectHeight
                                    } else {
                                        // buttonLeft = canvasObj.lowerCanvasEl.id == 'candidateNoCanvas' ? buttonGroupLeft - 25 - (buttonsInGroup.length - index) * buttonSpacing : buttonGroupLeft - (buttonsInGroup.length - index) * buttonSpacing
                                        buttonLeft = buttonGroupLeft - (buttonsInGroup.length - index) * buttonSpacing
                                        buttonTop = rectTop + rectHeight
                                    }
                                }
                            } else {
                                if (rectTop > canvasHeight / 2) {
                                    //左上角
                                    if (button == buttonsInGroup[0] || button == buttonsInGroup[1]) {
                                        //buttonLeft = canvasObj.lowerCanvasEl.id == 'subjectiveItemCanvas' ? buttonGroupLeft - rectWidth + 50 : buttonGroupLeft - rectWidth
                                        buttonLeft = buttonGroupLeft - rectWidth
                                        buttonTop = buttonGroupTop
                                    } else {
                                        //buttonLeft = buttonGroupLeft - 50 - rectWidth + (index + 1) * buttonSpacing
                                        buttonLeft = buttonGroupLeft - 100 - rectWidth + (index + 1) * buttonSpacing
                                        // buttonLeft = canvasObj.lowerCanvasEl.id == 'subjectiveItemCanvas' ? buttonGroupLeft - 100 - rectWidth + (index + 1) * buttonSpacing : buttonGroupLeft - 50 - rectWidth + (index + 1) * buttonSpacing
                                        buttonTop = buttonGroupTop
                                    }
                                } else {
                                    if (button == buttonsInGroup[0]) {
                                        buttonLeft = buttonGroupLeft - rectWidth
                                        buttonTop = rectTop + rectHeight
                                    } else {
                                        buttonLeft = buttonGroupLeft - 50 - rectWidth + index * buttonSpacing
                                        buttonTop = rectTop + rectHeight
                                    }
                                }
                            }
                            button.set({ left: buttonLeft, top: buttonTop })
                            canvasObj.add(button)
                            button.setCoords()
                        })
                    }
                    //渲染题号（主观题）
                    if (textGroups && textGroups.length > 0) {
                        var textInGroup = textGroups.filter(function (obj) {
                            return obj.selectedRect === rectangle
                        })
                        if (textInGroup && textInGroup.length > 0) {
                            textInGroup.forEach(function (text) {
                                text.set({ left: rectLeft, top: rectTop - 20 })
                                canvasObj.add(text)
                                text.sendToBack()
                            })
                        }
                    }
                })
                canvasObj.renderAll()
                // let res = { list: totalRect, _list: saveCoordinatesList }
                resolve()
            }
        })
    },  //页面切换
    reducedRect: function (image, canvasObj, paperImgs, imgSrc) {
        var backgroundImage = new Image()
        backgroundImage.src = image
        backgroundImage.crossOrigin = 'anonymous'
        var canvasWidth = canvasObj.width
        var canvasHeight = canvasObj.height
        // 计算背景图片缩放比例
        var imgScaleX = canvasWidth / backgroundImage.width
        var imgScaleY = canvasHeight / backgroundImage.height
        // 获取所有矩形和按钮组对象
        var rectangles = canvasObj.getObjects('rect')
        var texttangles = null
        texttangles = canvasObj.getObjects('text')
        if (texttangles && texttangles.length > 0) {
            texttangles.forEach(function (texttangle) {
                canvasObj.remove(texttangle)
            })
            texttangles.forEach(function (texttangle) {
                texttangle.set({
                    left: Number((texttangle.left / imgScaleX).toFixed(2)), // 距离画布左边的距离
                    top: Number((texttangle.top / imgScaleY).toFixed(2)), // 距离画布顶部的距离
                    fill: 'red', // 文字颜色
                    fontSize: 15, // 字体大小
                    fontFamily: 'Arial', // 字体类型
                    angle: 0, // 旋转角度
                    selectable: false,
                })
                canvasObj.add(texttangle)
            })
        }
        if (rectangles && rectangles.length > 0) {
            rectangles.forEach(function (rectangle) {
                canvasObj.remove(rectangle)
            }) // 移除每个矩形对象
            rectangles.forEach(function (rectangle) {
                if (
                    (paperImgs.length > 0 && imgSrc == paperImgs[0].image && rectangle.isFront == false) ||
                    (paperImgs.length > 1 && imgSrc == paperImgs[1].image && rectangle.isFront == true)
                ) {
                    var rectLeft = Number((rectangle.left / imgScaleX).toFixed(2))
                    var rectTop = Number((rectangle.top / imgScaleY).toFixed(2))
                    var rectWidth = Number((rectangle.width / imgScaleX).toFixed(2))
                    var rectHeight = Number((rectangle.height / imgScaleY).toFixed(2))

                    // 更新矩形对象的位置和大小
                    rectangle.set({ left: rectLeft, top: rectTop, width: rectWidth, height: rectHeight })
                    if (rectangle.line) rectangle.line.set({ x1: rectangle.line.x1 / imgScaleX, y1: rectangle.line.y1 / imgScaleY, x2: rectangle.line.x2 / imgScaleX, y2: rectangle.line.y2 / imgScaleY, })
                }
                canvasObj.add(rectangle)
                if (rectangle.line) canvasObj.add(rectangle.line)
            }) // 遍历每个矩形对象
        }
        canvasObj.renderAll()
    },  //还原矩形位置
    showHideRectBtn: function (canvasObj, isEditPaperTemp, imgIsFront, paperImgs, imgSrc) {
        canvasObj.getObjects().forEach((obj) => {
            if (imgIsFront) {
                //正面
                if (obj.isFront && obj.editButton) {
                    this.showsetCustomControlsbutton(obj)
                }
                if (!isEditPaperTemp && obj.editButton) {
                    obj.visible = true
                    obj.editButton.visible = false
                    this.hidesetCustomControlsbutton(obj)
                }
                if (obj.stroke == 'green' && isEditPaperTemp && obj.editButton) {
                    obj.visible = true
                    obj.editButton.visible = true
                    this.hidesetCustomControlsbutton(obj)
                }
                if (!obj.isFront && obj.editButton) {
                    obj.editButton.visible = false
                    obj.visible = false
                    this.hidesetCustomControlsbutton(obj)
                }
                if (obj.type == 'line') {
                    if (obj.isFront) obj.visible = true   //正面线定位
                    else obj.visible = false
                }
            } else {
                //反面
                if (!obj.isFront && obj.editButton && obj.editButton) {
                    this.showsetCustomControlsbutton(obj)
                }
                if (!isEditPaperTemp && obj.editButton) {
                    obj.visible = true
                    obj.editButton.visible = false
                    this.hidesetCustomControlsbutton(obj)
                }
                if (obj.stroke == 'green' && isEditPaperTemp && obj.editButton) {
                    obj.visible = true
                    obj.editButton.visible = true
                    this.hidesetCustomControlsbutton(obj)
                }
                if (obj.isFront && obj.editButton) {
                    obj.editButton.visible = false
                    obj.visible = false
                    this.hidesetCustomControlsbutton(obj)
                }
                if (obj.type == 'line') {
                    if (!obj.isFront) obj.visible = true   //反面线定位
                    else obj.visible = false
                }
            }
            // //只显示正面的客观题及题号（暂时只考虑正面情况）
            // if (paperImgs.length > 1 && imgSrc == paperImgs[1].image) {
            //     if (obj.isOptions || obj.text) obj.visible = false
            // } else if (imgSrc == paperImgs[0].image) {
            //     if (obj.isOptions || obj.text) obj.visible = true
            // }
            //显示客观题及题号、手阅卡打分栏
            if (obj.isOptions || obj.text || obj.isScoreRect) {
                if ((paperImgs.length > 1 && imgSrc == paperImgs[1].image && !obj.isFront) || (paperImgs.length > 0 && imgSrc == paperImgs[0].image && obj.isFront)) obj.visible = true
                else obj.visible = false
            }
            if (canvasObj.lowerCanvasEl.id == 'objectiveItemCanvas' || canvasObj.lowerCanvasEl.id == 'subjectiveItemCanvas') {
                if (obj.editButton) obj.editButton.visible = false
                if (obj.saveButton) obj.saveButton.visible = false
                if (obj.deleteButton) obj.deleteButton.visible = false
                if (obj.sizeButton) obj.sizeButton.visible = false
            }
            //线定位-线不显示控制点
            if (canvasObj.lowerCanvasEl.id == 'lineLocationCanvas') {
                obj.setControlsVisibility({
                    mt: false,
                    mb: false,
                    ml: false,
                    mr: false,
                    mtr: false,
                    tl: false,
                    tr: false,
                    bl: false,
                    br: false,
                })
            }
        })
    }, //隐藏按钮或矩形
    showEditRectButton: function (totalRect, canvasObj) {
        for (var i = 0; i < totalRect.length; i++) {
            var button = totalRect[i]
            if (button.editButton !== undefined && button.editButton !== null) {
                if ((button.isFront && button.visible) || (!button.isFront && button.visible)) {
                    button.editButton.visible = true
                }
                if ((button.isFront && !button.visible) || (!button.isFront && !button.visible) || button.stroke == '#409EFF') {
                    button.editButton.visible = false
                }
            }
        }
        canvasObj.renderAll()
    },//点击修改模板时按钮显示状态
}
export default makeTemplateCommon